import { MutationTree } from "vuex"
import { WidgetState } from "@/apps/StudentExchangeOverviewWidget/models/store-viewmodel"
import { ILabels, ILanguage } from "@/apps/StudentExchangeOverviewWidget/models/config-viewmodel"
import { IStudies } from "@/apps/StudentExchangeOverviewWidget/models/studies-viewmodel"

export default <MutationTree<WidgetState>>{
    loading(state, loading: boolean) {
        state.loading = loading
    },
    language(state, language: ILanguage) {
        state.language = language
    },
    labels(state, labels: ILabels) {
        state.labels = labels
    },
    studies(state, studies: IStudies) {
        state.studies = studies
    },
    selectedFilterYear(state, selectedFilterYear: string) {
        state.selectedFilterYear = selectedFilterYear
    },
    selectedFilterStudy(state, selectedFilterStudy: string) {
        state.selectedFilterStudy = selectedFilterStudy
    },
    isModalOpen(state, isModalOpen: boolean) {
        state.isModalOpen = isModalOpen
    },
    offset(state, offset: number) {
        state.offset = offset
    }
}
